import withRequiredAdmin from '../../HOC/withRequiredAdmin';
import AdminTrainings from './AdminTrainings';

export default withRequiredAdmin(AdminTrainings);
